import { defineAsyncComponent } from 'vue'
export default{
	install(Vue){   //注册全局的公共组件
		Vue.component('lidaSelect', 
			defineAsyncComponent({
				loader: () => import('./index.vue'),
			})
		);
	}
}